<template>
  <transition
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
    @after-leave="afterLeave">
    <slot></slot>
  </transition>
</template>

<script>
  import { prefersReducedMotion } from '@/utils/index.js';

  export default {
    name: 'CollapseTransition',
    props: {
      duration: {
        type: Number,
        default: 220
      }
    },
    computed: {
      easing(){
        return 'height ' + this.duration + 'ms cubic-bezier(0.22, 0.61, 0.36, 1), opacity ' +
          this.duration + 'ms cubic-bezier(0.22, 0.61, 0.36, 1)';
      }
    },
    methods: {
      beforeEnter(el){
        el.style.overflow = 'hidden';
        el.style.height = '0';
        el.style.opacity = '0';
      },
      enter(el, done){
        if(prefersReducedMotion()){
          done();
          return;
        }
        el.style.transition = this.easing;
        /* read scrollHeight after the collapsed styles are committed so the browser
           keeps two distinct height values to interpolate between */
        const targetHeight = el.scrollHeight;
        window.requestAnimationFrame(() => {
          el.style.height = targetHeight + 'px';
          el.style.opacity = '1';
        });
        setTimeout(done, this.duration);
      },
      afterEnter(el){
        this.resetStyle(el);
      },
      beforeLeave(el){
        el.style.overflow = 'hidden';
        el.style.height = el.scrollHeight + 'px';
        el.style.opacity = '1';
      },
      leave(el, done){
        if(prefersReducedMotion()){
          done();
          return;
        }
        el.style.transition = this.easing;
        window.requestAnimationFrame(() => {
          el.style.height = '0';
          el.style.opacity = '0';
        });
        setTimeout(done, this.duration);
      },
      afterLeave(el){
        this.resetStyle(el);
      },
      resetStyle(el){
        el.style.transition = '';
        el.style.height = '';
        el.style.opacity = '';
        el.style.overflow = '';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/general/CollapseTransition.vue